import {useEffect, Suspense, lazy} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import styled from 'styled-components'
import { useAuth } from '../../app/modules/auth'
import {soundPlayerService} from '../../app/services/SoundPlayerService'

// Lazy load BB8 component
const BB8 = lazy(() => import('../partials/easter/rolling-bb8'))

const BB8Container = styled.div`
  position: fixed;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 200px;
  z-index: 100;
  pointer-events: none;
  
  > div {
    pointer-events: auto;
    margin: 0 auto;
  }
`

const MasterLayout = () => {
  const {currentUser} = useAuth()
  const location = useLocation()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  // Initialize sound player service for all users
  useEffect(() => {
    console.log('🔊 MasterLayout: currentUser data:', currentUser);
    console.log('🔊 MasterLayout: currentUser.decoded?.id:', currentUser?.decoded?.id);
    
    if (currentUser?.decoded?.id) {
      console.log('🔊 MasterLayout: Initializing sound service for user ID:', currentUser.decoded.id, 'email:', currentUser.decoded.email);
      soundPlayerService.initialize(currentUser.decoded.id, currentUser.decoded.email).catch(console.error)
      
      // Cleanup on unmount or user change
      return () => {
        soundPlayerService.disconnect()
      }
    } else {
      console.log('🔊 MasterLayout: No currentUser.decoded.id available');
    }
  }, [currentUser?.decoded?.id])

  const showBB8 = currentUser?.decoded?.email === 'mauricio.robles@designereyes.com' ||
                  currentUser?.decoded?.email === 'lucas.pimentel@designereyes.com' ||
                  currentUser?.decoded?.email === 'lucas.user2@designereyes.com'

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <style>
          {`
            @keyframes gradient {
              0% { background-position: 0% 50%; }
              50% { background-position: 100% 50%; }
              100% { background-position: 0% 50%; }
            }
          `}
        </style>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
        {showBB8 && (
          <Suspense fallback={null}>
            <BB8Container>
              <BB8 initialSpeed={1} initialAcceleration={0.2} />
            </BB8Container>
          </Suspense>
        )}
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}

